<template lang="html">
  <div class="card dashboard">
    <header class="card-header">
      <p class="card-header-title">
        <router-link to="/bookmarks" class="has-text-dark">
          <span class="icon is-medium">
            <icon 
              icon="heart" 
              size="m" />
          </span>
          <span class="has-text-weight-light is-size-4 ml-2">Mijn favorieten</span>
        </router-link>
      </p>
    </header>
    <div class="card-content">
      <div class="columns is-gapless" v-if="bookmarkCount >= 1">
        <div class="column has-text-centered">
          <router-link to="/bookmarks">
            <span class="tag is-rounded is-medium" :style="badgeStyle">{{ bookmarkCount }}</span>
          </router-link>
        </div>
      </div>
      <article class="message is-info" v-if="bookmarkCount === 0">
        <div class="message-body">
          Je hebt nog geen favorieten gekozen
        </div>
      </article>
    </div>
    <footer class="card-footer">
      <router-link to="/bookmarks" class="card-footer-item">Mijn favorieten</router-link>
    </footer>
  </div>
</template>

<script>

import icon from '../../common/icon'

export default {
  name: 'bookmarks',
  data: function () {
    return {
      bookmarkCount: 0
    }
  },
  methods: {
    getBookmarks: function () {
      this.$bus.$emit('loadingEvent', true)
      this.$api.get('me/bookmarks').then((response) => {
        this.bookmarkCount = response.data.data.length

        this.$bus.$emit('loadingEvent', false)
        this.disabled = false
      }, (error) => {
        this.$bus.$emit('loadingEvent', false)
        this.disabled = false
        this.$bus.$emit('apiErrorEvent', error)
      })
    }
  },
  mounted: function () {
    this.getBookmarks()
  },
  computed: {
    badgeStyle: function () {
      return { 
        'background-color': this.$root.$data.theme.buttonColor,
        'color': 'white'
      }
    }
  },
  components: {
    'icon': icon
  }
}
</script>
